import { render, staticRenderFns } from "./FullContainer.vue?vue&type=template&id=2dfd5764&"
import script from "./FullContainer.vue?vue&type=script&lang=js&"
export * from "./FullContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports